import { useEffect } from "react";

const IOS_STORE_URL = "https://testflight.apple.com/join/9yC3fSQs";
const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.parallelpoker.texasholdem";
const DESKTOP_FALLBACK = "https://parallelpoker.com/";

const DownloadRedirector = () => {
  const handleRedirect = () => {
    try {
      const ua = navigator.userAgent;
      //console.log("ua: " + ua)
      const isIOS = /iPad|iPhone|iPod/.test(ua);
      const isAndroid = /Android/.test(ua);

      if (!isIOS && !isAndroid) {
        window.location.replace(DESKTOP_FALLBACK);
        return;
      }

      if (isIOS) {
        window.location.replace(IOS_STORE_URL);
      } else if (isAndroid) {
        window.location.replace(ANDROID_STORE_URL);
      }
    } catch (err) {
      alert(err)
    }
  }


  useEffect(() => {
    handleRedirect()
  }, []);

  return (
    <div>
      <h1>Redirecting...</h1>
      <button onClick={handleRedirect}>
        Take me there
      </button>
    </div>
  );
};

export default DownloadRedirector;
